export enum EOnboardingPlacement {
  Top = "Top",
  Bottom = "Bottom",
  Left = "Left",
  Right = "Right",
  Center = "Center",
}

export interface IOnboardingStep {
  id: string;
  stepOrder: number;
  route: string | null;
  targetSelector: string | null;
  title: string;
  content: string;
  placement: EOnboardingPlacement;
}

export interface IOnboardingFeature {
  id: string;
  featureKey: string;
  title: string;
  steps: IOnboardingStep[];
}

export interface ICompleteOnboardingCommand {
  featureId: string;
  isSkipped: boolean;
}
